module.exports = __webpack_public_path__ + "img/bg-login-v4.49258ef5.png";